module.exports = __webpack_public_path__ + "img/4_Website_Banner_boy_plate.6e840260.jpg";